const Menu = [
	{ 'text': 'APP INTERFACE', 'is_header': true },
	{ 'path': '/dashboard', 'icon': 'ph:rocket-duotone', 'text': 'DASHBOARD' }, 
	{ 'path': '/analytics', 'icon': 'ph:chart-bar-duotone', 'text': 'ANALYTICS' }, 
	{ 'path': '/email', 'icon': 'ph:envelope-duotone', 'text': 'EMAIL', 'children': [
			{ 'path': '/email/inbox', 'text': 'INBOX' 	}, 
			{ 'path': '/email/compose', 'text': 'COMPOSE' }, 
			{ 'path': '/email/detail', 'text': 'DETAIL' }
		]
	}, 
	{ 'is_divider': true },
	{ 'text': 'UXUI COMPONENTS', 'is_header': true },
	{ 'path': '/widgets', 'icon': 'ph:stack-duotone', 'text': 'WIDGETS' },
	{ path: '/ai', icon: 'ph:sparkle-duotone', text: 'AI STUDIO',
		children: [
			{ path: '/ai/chat', text: 'AI CHAT' }, 
			{ path: '/ai/image-generator', text: 'AI IMAGE GENERATOR' }
		]
	},
	{ 'path': '/pos', 'icon': 'ph:handbag-simple-duotone', 'text': 'POS SYSTEM', 'children': [
			{ 'path': '/pos/customer-order', 'text': 'CUSTOMER ORDER' }, 
			{ 'path': '/pos/kitchen-order', 'text': 'KITCHEN ORDER' }, 
			{ 'path': '/pos/counter-checkout', 'text': 'COUNTER CHECKOUT' }, 
			{ 'path': '/pos/table-booking', 'text': 'TABLE BOOKING' }, 
			{ 'path': '/pos/menu-stock', 'text': 'MENU STOCK' }
		]
	},
	{ 'path': '/ui', 'icon': 'ph:game-controller-duotone', 'text': 'UI KITS', 'children': [
			{ 'path': '/ui/bootstrap', 'text': 'BOOTSTRAP' }, 
			{ 'path': '/ui/buttons', 'text': 'BUTTONS' }, 
			{ 'path': '/ui/card', 'text': 'CARD' }, 
			{ 'path': '/ui/icons', 'text': 'ICONS' }, 
			{ 'path': '/ui/modal-notifications', 'text': 'MODAL & NOTIFICATIONS' }, 
			{ 'path': '/ui/typography', 'text': 'TYPOGRAPHY' }, 
			{ 'path': '/ui/tabs-accordions', 'text': 'TABS & ACCORDIONS' }
		]
	},
	{ 'path': '/form', 'icon': 'ph:pencil-simple-duotone', 'text': 'FORMS', 'children': [
			{ 'path': '/form/elements', 'text': 'FORM ELEMENTS' }, 
			{ 'path': '/form/plugins', 'text': 'FORM PLUGINS' }, 
			{ 'path': '/form/wizards', 'text': 'WIZARDS' }
		]
	},
	{ 'path': '/table', 'icon': 'ph:grid-nine-duotone', 'text': 'TABLES', 'children': [
			{ 'path': '/table/elements', 'text': 'TABLE ELEMENTS' }, 
			{ 'path': '/table/plugins', 'text': 'TABLE PLUGINS' }
		]
	},
	{ 'path': '/chart', 'icon': 'ph:chart-donut-duotone', 'text': 'CHARTS', 'children': [
			{ 'path': '/chart/js', 'text': 'CHART.JS' },
			{ 'path': '/chart/apex', 'text': 'APEXCHARTS.JS' }
		]
	},
	{ 'path': '/map', 'icon': 'ph:map-pin-area-duotone', 'text': 'MAP' },
	{ 'path': '/layout', 'icon': 'ph:terminal-window-duotone', 'text': 'LAYOUT', 'children': [
			{ 'path': '/layout/starter', 'text': 'STARTER PAGE' }, 
			{ 'path': '/layout/fixed-footer', 'text': 'FIXED FOOTER' }, 
			{ 'path': '/layout/full-height', 'text': 'FULL HEIGHT' }, 
			{ 'path': '/layout/full-width', 'text': 'FULL WIDTH' }, 
			{ 'path': '/layout/boxed-layout', 'text': 'BOXED LAYOUT' }, 
			{ 'path': '/layout/collapsed-sidebar', 'text': 'COLLAPSED SIDEBAR' }, 
			{ 'path': '/layout/top-nav', 'text': 'TOP NAV' }, 
			{ 'path': '/layout/mixed-nav', 'text': 'MIXED NAV' }, 
			{ 'path': '/layout/mixed-nav-boxed-layout', 'text': 'MIXED NAV BOXED LAYOUT' }
		]
	},
	{ 'path': '/pages', 'icon': 'ph:open-ai-logo-duotone', 'text': 'PAGES', 'children': [
			{ 'path': '/pages/scrum-board', 'text': 'SCRUM BOARD' }, 
			{ 'path': '/pages/products', 'text': 'PRODUCTS' }, 
			{ 'path': '/pages/product-details', 'text': 'PRODUCT DETAILS' }, 
			{ 'path': '/pages/orders', 'text': 'ORDERS' }, 
			{ 'path': '/pages/order-details', 'text': 'ORDER DETAILS' }, 
			{ 'path': '/pages/gallery', 'text': 'GALLERY' }, 
			{ 'path': '/pages/search-results', 'text': 'SEARCH RESULTS' }, 
			{ 'path': '/pages/coming-soon', 'text': 'COMING SOON PAGE' }, 
			{ 'path': '/pages/error', 'text': 'ERROR PAGE' }, 
			{ 'path': '/pages/login', 'text': 'LOGIN' }, 
			{ 'path': '/pages/register', 'text': 'REGISTER' }, 
			{ 'path': '/pages/data-management', 'text': 'DATA MANAGEMENT' }, 
			{ 'path': '/pages/pricing', 'text': 'PRICING PAGE' }
		]
	},
	{ 'is_divider': true },
	{ 'text': 'USER PORTAL', 'is_header': true },
	{ 'path': '/file-manager', 'icon': 'ph:folder-duotone', 'text': 'FILE MANAGER' },
	{ 'path': '/messenger', 'icon': 'ph:messenger-logo-duotone', 'text': 'MESSENGER' },
	{ 'path': '/profile', 'icon': 'ph:user-focus-duotone', 'text': 'PROFILE' },
	{ 'path': '/calendar', 'icon': 'ph:calendar-duotone', 'text': 'CALENDAR' },
	{ 'path': '/settings', 'icon': 'ph:gear-duotone', 'text': 'SETTINGS' },
	{ 'path': '/helper', 'icon': 'ph:first-aid-kit-duotone', 'text': 'HELPER' }
];

export default Menu;